import { render, staticRenderFns } from "./GroupTestReport.vue?vue&type=template&id=68059c00&"
import script from "./GroupTestReport.vue?vue&type=script&lang=ts&"
export * from "./GroupTestReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports